import React, { useState, useEffect } from 'react';
import VersionChangelog from './VersionChangelog';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Footer = () => {
  const [footerText, setFooterText] = useState('');
  const [appVersion, setAppVersion] = useState('');
  const [showChangelog, setShowChangelog] = useState(false);

  useEffect(() => {
    const fetchFooterSettings = async () => {
      try {
        const response = await fetch(`${BACKEND_URL}/api/admin/settings`);
        const data = await response.json();
        if (data.settings?.footer?.text) {
          setFooterText(data.settings.footer.text);
        }
        if (data.appVersion) {
          setAppVersion(`v${data.appVersion}`);
        }
      } catch (error) {
        console.error('Error fetching footer settings:', error);
      }
    };
    
    fetchFooterSettings();
  }, []);

  return (
    <>
      <footer className="bg-slate-800 text-slate-400 py-4 mt-auto">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <p className="text-sm">
            {footerText}{footerText && appVersion ? ' ' : ''}
            {appVersion && (
              <span 
                className="text-slate-500 cursor-pointer hover:text-cyan-400 transition-colors"
                onClick={() => setShowChangelog(true)}
                title="View changelog"
                data-testid="app-footer-version-link"
              >
                {appVersion}
              </span>
            )}
          </p>
        </div>
      </footer>
      {showChangelog && (
        <VersionChangelog 
          currentVersion={appVersion.replace('v', '')} 
          onClose={() => setShowChangelog(false)} 
        />
      )}
    </>
  );
};

export default Footer;
